module.exports = __webpack_public_path__ + "static/img/logo.4656ee4f.jpg";